<div *ngIf="data.type!=='like'" style="text-align:center;white-space: pre-wrap;">
  <div *ngIf="!data.icon">{{ data.message }}</div>
  <div *ngIf="data.icon" style="display:flex;gap:8px;align-items: center;justify-content: center;">
    <img [src]="data.icon" style="height:36px">
    <div>{{ data.message }}</div>
  </div>
</div>
<div *ngIf="data.type==='like'">
  <div
    style="justify-content: center;white-space: pre-wrap;display:flex;gap:2px;align-items:center;margin-bottom: 1px;">
    <img src="/assets/new/heart-red-on.svg">
    <div>찜한 여행에 저장!</div>
  </div>
  <div style="text-align:center;font-size:14px;">나의노는법>찜한 여행에서 <span style="text-decoration:underline;cursor:pointer;"
      (click)="openWishlist()">확인</span></div>
</div>